import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { JwtAuthService } from '../services/auth/jwt-auth.service';
import { UrlService } from '../services/url.service';
import { LocalStoreService } from '../services/local-store.service';
import { ExamCollectorsEntityService } from '../../state/entity-services/exam-collectors-entity.service';
import { map } from 'rxjs/operators';

@Injectable()
export class PatientExamCollectorGuard implements CanActivate {

  firstTimeVisitPatientExamsPage = 'firstTimeVisitPatientExamsPage';

  constructor(
    private examCollectorsEntityService: ExamCollectorsEntityService,
    private localStoreService: LocalStoreService,
    private urlService: UrlService,
    private jwtAuthService: JwtAuthService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (!this.jwtAuthService.isLoggedIn) {
      this.router.navigate(['/paciente/login/boas-vindas'], {
        queryParams: {
          return: state.url,
        },
      });
      return of(true);
    }
    return this.examCollectorsEntityService.getAllExamColletorsAvailable()
      .pipe(
        map(examCollectors => {
          if (examCollectors?.length > 0 && !this.getFirstTimeVisitPatientExamsPage) {
            this.setFirstTimeVisitPatientExamsPage();
            this.redirectTo(this.urlService.personHomeExamCollector(), { showNextTimeButton: true });
          }
          return true;
        })
      );
  }


  private redirectTo(path: string, queryParams = {}): void {
    this.router.navigate([path], { queryParams, queryParamsHandling: 'merge' });
  }

  setFirstTimeVisitPatientExamsPage() {
    this.localStoreService.setItem(this.firstTimeVisitPatientExamsPage, true);
  }

  get getFirstTimeVisitPatientExamsPage() {
    return this.localStoreService.getItem(this.firstTimeVisitPatientExamsPage);
  }
}
